export default [
	'Under Qualified',
	'Over Qualified',
	'Not Relevant',
	'Expectations Mismatch',
	'Not shortlisted after screening'
];
